import { config } from 'app/config'

export const LOGO_URL_DARK_SVG = `${config.STATIC_ASSETS_URL}/images/Logo-DarkBlue.svg`
export const LOGO_URL_LIGHT_SVG = `${config.STATIC_ASSETS_URL}/images/Logo-White.svg`
